import React from "react";

const CheckboxField = ({
  label,
  name,
  checked,
  onChange,
  required = false,
  readOnly = false,
}) => {
  return (
    <div className="flex items-start space-x-3">
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={!!checked}
        onChange={onChange}
        required={required}
        disabled={readOnly}
        className={`h-4 w-4 rounded-sm border transition-colors focus:ring-1 focus:ring-ring focus:ring-offset-0 ${
          readOnly
            ? "border-gray-200 bg-gray-50 cursor-not-allowed"
            : "border-gray-200 text-primary hover:border-gray-300 focus:border-primary"
        }`}
      />
      <label
        htmlFor={name}
        className={`text-sm leading-relaxed ${
          readOnly ? "text-muted-foreground" : "text-foreground"
        } ${readOnly ? "cursor-not-allowed" : "cursor-pointer"}`}
      >
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
    </div>
  );
};

export default CheckboxField;
